import { render, staticRenderFns } from "./TeamStat2021.vue?vue&type=template&id=ee43de3e&"
import script from "./TeamStat2021.vue?vue&type=script&lang=js&"
export * from "./TeamStat2021.vue?vue&type=script&lang=js&"
import style0 from "./TeamStat2021.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports